import gql from 'graphql-tag';

import { getSingleProp, prepareACDebugContext } from 'src/utils/lib/graphql';
import apolloClient from 'src/store/client';
import { FRAGMENT_RECOMPOSE_REQUEST } from './schema';

const MUTATION = gql`
  mutation RephraseTextsForDocumentEditor(
    $projectId: ID!
    $originalVariationId: ID
    $assetType: String
    $generationTool: GenerationToolEnum!
    $brief: BriefInput
    $scoringMethod: ScoringMethodInput
    $productName: String
    $text: String!
    $recomposeMode: String
    $keywords: String
    $language: String!
    $languageTargetFormality: LanguageTargetFormalityEnum
    $numberOfVariations: Int!
    $tone: String
    $agePreset: AgePresetEnum
    $tovId: ID
    $debugAcPrompt: String
    $sourceType: String
    $onlyImproveScore: Boolean
    $forceImproveReason: Boolean
    $customerPersonaId: ID
    $annotations: [SuggestionAnnotationInput!]
    $manualInstructions: String
  ) {
    rephraseTextsForDocumentEditor(
      projectId: $projectId
      originalVariationId: $originalVariationId
      assetType: $assetType
      generationTool: $generationTool
      brief: $brief
      scoringMethod: $scoringMethod
      productName: $productName
      text: $text
      recomposeMode: $recomposeMode
      keywords: $keywords
      language: $language
      languageTargetFormality: $languageTargetFormality
      numberOfVariations: $numberOfVariations
      tone: $tone
      agePreset: $agePreset
      tovId: $tovId
      debugAcPrompt: $debugAcPrompt
      sourceType: $sourceType
      onlyImproveScore: $onlyImproveScore
      forceImproveReason: $forceImproveReason
      customerPersonaId: $customerPersonaId
      annotations: $annotations
      manualInstructions: $manualInstructions
    ) {
      ...RecomposeRequest
    }
  }
  ${FRAGMENT_RECOMPOSE_REQUEST}
`;

export const rephraseTextsForDocumentEditor = async (
  {
    projectId,
    originalVariationId,
    assetType,
    generationTool,
    brief,
    scoringMethod,
    productName,
    text,
    recomposeMode,
    keywords,
    language,
    numberOfVariations,
    tone,
    agePreset,
    tovId,
    debugAcPrompt,
    languageTargetFormality,
    sourceType,
    onlyImproveScore,
    forceImproveReason,
    customerPersonaId,
    annotations,
    manualInstructions,
  },
  options
) => {
  const variables = {
    projectId,
    originalVariationId,
    assetType,
    generationTool,
    brief,
    scoringMethod,
    productName,
    text,
    recomposeMode,
    keywords,
    language,
    numberOfVariations,
    tone,
    agePreset,
    tovId,
    debugAcPrompt,
    languageTargetFormality,
    sourceType,
    onlyImproveScore,
    forceImproveReason,
    customerPersonaId,
    annotations,
    manualInstructions,
  };
  const mutateOptions = {
    mutation: MUTATION,
    variables,
    context: prepareACDebugContext('document recompose', variables),
  };

  if (options?.abortSignal) {
    mutateOptions.context = {
      ...mutateOptions.context,
      fetchOptions: {
        signal: options.abortSignal,
      },
    };
  }

  const response = await apolloClient.mutate(mutateOptions);
  return getSingleProp(response.data);
};
